import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import { Hero } from './components/Hero';
import { Navbar } from './components/Navbar';
import { About } from './components/About';
import { Services } from './components/Services';
import { Methodology } from './components/Methodology';
import { Contact } from './components/Contact';
import { ScrollToTop } from './components/ScrollToTop';

// Componente para la página de Inicio (Home)
const Home = () => {
  return (
    <>
      <div id="inicio">
        <Hero />
      </div>
      <div id="servicios">
        <Services />
      </div>
      <Methodology />
      
      {/* SECCIÓN CTA */}
      <section className="py-32 bg-gray-50 text-every-blue text-center border-y border-gray-100 px-8">
        <h2 className="text-3xl md:text-5xl font-montserrat font-light italic max-w-5xl mx-auto leading-tight">
          "Haz crecer tu negocio con nuestra experiencia en tecnología e innovación."
        </h2>
        <div className="mt-10">
          <a href="#contacto" className="bg-every-blue text-white px-10 py-4 rounded-full font-bold uppercase tracking-widest hover:bg-every-gold transition-colors shadow-lg">
            Trabajemos juntos
          </a>
        </div>
      </section>

      <div id="contacto">
        <Contact />
      </div>
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white font-montserrat scroll-smooth">
        <Navbar />
        
        <Routes>
          {/* Ruta Principal: Home */}
          <Route path="/" element={<Home />} />
          
          {/* Ruta Independiente: Quiénes Somos */}
          <Route path="/quienes-somos" element={<About />} />
        </Routes>

        {/* FOOTER: Identidad visual completa */}
        <footer className="bg-every-blue text-every-gray py-20 text-center text-sm border-t border-white/5">
          <div className="max-w-7xl mx-auto px-6 text-center">
            
            {/* Logo en Blanco */}
            <Link to="/" className="inline-block">
              <img 
                src="/everytech-brand-logo-white.png?v=2" 
                alt="Every Technology Logo" 
                className="h-14 md:h-16 mx-auto mb-8 object-contain hover:opacity-90 transition-opacity" 
              />
            </Link>
            
            <div className="mb-8 space-y-2">
              <p className="font-bold text-white text-xl md:text-2xl uppercase tracking-[0.25em]">
                EVERY TECHNOLOGY S.A.S.
              </p>
              <p className="text-every-gold font-semibold tracking-wider text-sm md:text-base">
                NIT 901930925-6
              </p>
              <p className="text-xs md:text-sm text-every-gray/80 font-light pt-1">
                Representante Legal: <span className="text-white font-medium">Lorena Ramírez Payares</span> (C.C. 1.003.376.970)
              </p>
              <p className="text-sm text-every-gray/80 font-light pt-2">
                <a href="mailto:info@everytech.co" className="hover:text-every-gold transition-colors">info@everytech.co</a>
                <span className="mx-3 opacity-40">|</span>
                <a href="tel:+573053412485" className="hover:text-every-gold transition-colors">+57 305 341 2485</a>
              </p>
            </div>

            {/* Redes Sociales */}
            <div className="flex justify-center gap-10 mb-10">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-every-gold transition-colors font-bold uppercase tracking-[0.2em] text-xs">LinkedIn</a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-every-gold transition-colors font-bold uppercase tracking-[0.2em] text-xs">Facebook</a>
            </div>

            <div className="pt-8 border-t border-white/10 text-every-gray/40 text-[10px] tracking-[0.3em] uppercase font-medium">
              © {new Date().getFullYear()} EVERY TECHNOLOGY S.A.S. NIT 901930925-6. Todos los derechos reservados.
            </div>
          </div>
        </footer>

        {/* Utilidades de Navegación */}
        <ScrollToTop />
      </div>
    </Router>
  );
}

export default App;